import React, { Component } from 'react';
import loadSchedule         from '../LoadEventSchedule';
import Slider               from '../components/Slider/Slider';

import Loader               from 'react-loader-spinner';

class ExampleDay1 extends Component {
    state = {
        event: [],
        error: null,
        isLoaded: false,
        slides: [
            {
                path: './img/МедиаСофт-ТОТАЛИЗАТОР.png',
                background: '#1b1a1a',
                type: 'image'
            },
            {
                path: './img/TaglineAwards.png',
                background: '#000015',
                type: 'image'
            },
            {
                path: './img/Ceremony/Ceremony.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/Ceremony/Sponsors.png',
                background: '',
                type: 'image'
            }
        ]
    };

    // Пример загрузки расписания на один и другой день
    componentDidMount() {
        const url = `1http://conf.tagline.nechego.ru/program/10/mgmt-prod-hr`;

        Promise.all([loadSchedule(url)])
            .then(values => {
                let slides = [...this.state.slides];

                this.setState({
                    slides: [...values[0], ...slides],
                    event: [],
                    isLoaded: true
                });

            })
            .catch(err => {
                console.error(err);
                this.setState({
                    isLoaded: true
                });
            });
    }

    render() {
        if (!this.state.isLoaded) {
            return (
                <div className="b-loader">
                    <Loader type="Watch" color="#bbb" height="100" width="100"/>
                </div>
            );
        }

        return (
            <Slider slides={ this.state.slides }/>
        );
    }

}

export default ExampleDay1;
